import { render, staticRenderFns } from "./PriceNew.vue?vue&type=template&id=d4f5134a&"
import script from "./PriceNew.vue?vue&type=script&lang=js&"
export * from "./PriceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports